import React, { Component } from "react";

import PropTypes from "prop-types";

class Restaurante extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);
    
    this.state = {}
  }

  restauranteClicked = () => {
    this.context.router.history.push("/restaurantes/" + this.props.item.identifier);
  }

  render() {
    return (
      <div
        onClick={this.restauranteClicked}
        className="food-and-drink__item"
        data-index="0"
      >
        <div className="clicking-div">
          <div className="food-and-drink__title">
            <span className="food-and-drink__name">{this.props.item.name}</span>
          </div>

          <div className="food-and-drink__categories">
            <span>{this.props.item.type}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default Restaurante;
